import { useEffect, useRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "ckeditor5/ckeditor5.css";
import "./EditorField.css";

const EditorField = ({
  register,
  name,
  label,
  setValue,
  defaultValue = "",
  errors,
  className,
}) => {
  const editorRef = useRef();

  useEffect(() => {
    if (editorRef.current) {
      setValue(name, editorRef.current.getData());
    }
  }, [defaultValue, name, setValue]);

  const config = {
    resize_minHeight: 300,
    resize_minHeight: 600,
  };

  return (
    <div className="input-container pb-1">
      <label className="block mb-0.5 text-text-1/90 font-medium" htmlFor={name}>
        {label}
      </label>
      <div
        className={`editor-container w-full ${className} text-text-1 bg-content h-auto`}
      >
        <CKEditor
          editor={ClassicEditor}
          data={defaultValue}
          onReady={(editor) => {
            editorRef.current = editor;
            register(name);
          }}
          onChange={(event, editor) => {
            setValue(name, editor.getData());
          }}
        />
      </div>
      {
        <p className="text-red-400 text-xs text-wrap w-fit">
          {errors && errors.message} <span className="invisible">Sample</span>
        </p>
      }
    </div>
  );
};

export default EditorField;
